<template>
    <div class="box">
        <div class="series">02</div>
        <div class="top-box">
            <span class="require">*</span>
            <p>试卷所属分类</p>
            <el-radio-group style="margin-left: 3rem;" @input="searchPaper" v-model="classifyCode">
                <el-radio v-for="(item, index) in Category" :key="index" :label="item.value">{{ item.label }}</el-radio>
            </el-radio-group>
        </div>
        <div class="content-box">
            <div class="left-box">
                <p class="left-title">试卷库</p>
                <div class="list-box">
                    <no-data v-if="paperList.length==0"></no-data>
                    <div v-for="(item, index) in paperList" class="paper-item" @click="changePaper(item)"
                        :class="{ 'paper-active': currentPaperIds[item.id] }" :key="index">
                        <div class="active-line" v-show="currentPaperIds[item.id]"></div>
                        <p class="paper-item-title">{{ item.testPaperName }}</p>
                        <div class="paper-bottom">
                            <div class="p-item">
                                <p>总分</p>
                                <p>{{ item.totalScore || 0 }}</p>
                                <p>分</p>
                            </div>
                            <div class="p-item">
                                <p>共</p>
                                <p>{{ item.questionCount || 0 }}</p>
                                <p>题</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="center-box">
                <div class="center-top">
                    <div class="search-box">
                        <p>题型</p>
                        <el-select style="width: 13.4rem;" @change="search" v-model="pages.type" placeholder="请选择">
                            <el-option v-for="item in options" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="search-box" style="margin-left: 4rem;">
                        <p>搜索</p>
                        <el-input style="width: 24rem;" @keydown.enter.native="search" clearable @clear="search" v-model="pages.keywords"
                            placeholder="请输入内容">
                            <template slot="prefix">
                                <div class="search-ipt-box">
                                    <img style="cursor: pointer;width: 16px;height: auto;"
                                        src="../../../../assets/image/magSys/search.png" @click="search" alt="">
                                </div>
                            </template>
                        </el-input>
                    </div>
                </div>
                <div class="center-table-box">
                    <Table :totalSize="pages.total" :pagination="true" :operationWidth="350"
                        :currentPage="pages.current" @changeCurrentPage="changeCurrentPage"
                        @changePageSize="changePageSize" :pageSize="pages.size" navHeight=40 ref="table"
                        :tableData="tableData" :tableKey="tableKey">
                        <template slot="operation" slot-scope="data">
                            <el-switch :disabled="isDetail" v-model="data.data.row.flag" @change="setQuestion(data.data.row)"
                                :active-value="true" :inactive-value="false"></el-switch>
                        </template>
                    </Table>
                </div>
            </div>
            <div class="right-box">
                <div class="exam-content">
                    <div class="content">
                        <div v-for="(item, index) in randomConfig" :key="index" class="sub-item">
                            <p>{{ item.label }}:</p>
                            <p>选取</p>
                            <p class="number-gap">{{ querySubTotal[item.label] }}</p>
                            <p>{{ `题, 每题` }}</p>
                            <el-input-number :disabled="isDetail" controls-position="right" class="number-input-box"
                                style="width: 12rem;margin: 0 1.5rem;" :min="0" v-model="item.score"></el-input-number>
                            <p>分，共</p>
                            <p class="number-gap overflow">{{ querySubTotal[item.label] * item.score || 0 }}</p>
                            <p>分</p>
                        </div>
                    </div>
                    <div class="exam-bottom-box">
                        <div class="item">
                            <div class="form-item">
                                <p>及格分数：</p>
                                <el-input-number :disabled="isDetail" :min="0" :max="computedTotalScore" class="number-input-box"
                                    v-model="form.passScore" controls-position="right"></el-input-number>
                                <p>分，总分{{ computedTotalScore }}分</p>
                            </div>
                        </div>
                        <div class="item">
                            <div class="form-item">
                                <p>答题时间：</p>
                                <el-input-number class="number-input-box" :disabled="isDetail" :min="0"
                                    v-model="form.examineTime" controls-position="right"></el-input-number>
                                <p>分钟</p>
                            </div>
                        </div>
                        <div class="item">
                            <div class="form-item">
                                <p>是否打乱题目顺序：</p>
                                <el-switch :disabled="isDetail" v-model="form.isMess"></el-switch>
                            </div>
                            <div class="form-item" style="margin-left: 3rem;">
                                <p>切屏次数限制：</p>
                                <el-input-number class="number-input-box" :disabled="isDetail" :min="0"
                                    v-model="form.screenLimit" controls-position="right"></el-input-number>
                            </div>
                        </div>
                        <div class="form-item">
                            <p>多选题得分机制：</p>
                            <el-radio-group :disabled="isDetail" v-model="form.multiMade">
                                <el-radio label="0">少选不得分</el-radio>
                                <el-radio label="1">少选得一分</el-radio>
                                <el-radio label="2">少选得平均分</el-radio>
                            </el-radio-group>
                        </div>
                        <div class="form-item">
                            <p>填空题得分机制：</p>
                            <el-radio-group :disabled="isDetail" v-model="form.fillMode">
                                <el-radio label="0">每题错一空不得分</el-radio>
                                <el-radio label="1">每题每空平均分</el-radio>
                            </el-radio-group>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Category } from '@/utils/utils';
import { PaperBankPageList, PaperQuestionPageList } from '@/api/examine';
import NoData from '../../../common/NoData.vue';
export default {
  components: { NoData },
    props: ['isDetail'],
    data() {
        return {
            Category,
            form: {
                passScore: 0,
                examineTime: 0,
                isMess: true,
                screenLimit:undefined,
                multiMade: '2',
                fillMode: '1'
            },
            /**当前选中试卷库 */
            currentPaperIds: {},
            /**过滤掉的题目 */
            clearQuestionIds: [],
            /**试卷所属分类 */
            classifyCode: Category[0].value,
            /**试卷库列表 */
            paperList: [],
            /**题型可选项 */
            options: [
                {
                    label: "全部",
                    value: ''
                },
                {
                    label: "判断题",
                    value: '判断题'
                },
                {
                    label: "填空题",
                    value: '填空题'
                },
                {
                    label: "单选题",
                    value: '单选题'
                },
                {
                    label: "多选题",
                    value: '多选题'
                },
            ],
            /**试卷库分页 */
            paperPages: {
                current: 1,
                size: 10,
                total: 0,
                keywords: '',
                type: ''
            },
            /**题目列表 */
            tableData: [],
            tableKey: [
                { name: '题干', value: 'questionStem', },
                { name: '题型', value: 'questionType', },
                { name: '操作', value: 'operation', slot: 'operation' },
            ],
            pages: {
                current: 1,
                size: 10,
                total: 0
            },
            /**随机选择题目的分数设置 */
            randomConfig: [
                {
                    label: '判断题',
                    score: 0,
                },
                {
                    label: '填空题',
                    score: 0,
                },
                {
                    label: '单选题',
                    score: 0,
                },
                {
                    label: '多选题',
                    score: 0,
                },
            ],
            /**排除的题目数量 */
            excludeSub:{}
        }
    },
    methods: {
        changeCurrentPage(e) {
            this.pages.current = e;
            this.paperQuestionPageList();
        },
        changePageSize(e) {
            this.pages.current = 1;
            this.pages.size = e;
            this.paperQuestionPageList();
        },
        search() {
            this.pages.current = 1;
            this.paperQuestionPageList();
        },
        /**设置题目 */
        setQuestion(item) {
            if(this.isDetail)return;
            if(!this.excludeSub[item.testPaperId]){
                let obj={
                    '判断题':0,
                    '填空题':0,
                    '单选题':0,
                    '多选题':0
                }
                this.$set(this.excludeSub,item.testPaperId,obj);
            }
            if (!item.flag) {
                let obj={
                    questionId:item.questionId,
                    questionType:item.questionType,
                    testPaperId:item.testPaperId
                }
                this.clearQuestionIds.push(obj);
                this.excludeSub[item.testPaperId][item.questionType]++;
            } else {
                let index = this.clearQuestionIds.findIndex(e => e.questionId == item.questionId);
                if (index != -1) {
                    this.clearQuestionIds.splice(index, 1);
                    this.excludeSub[item.testPaperId][item.questionType]--;
                }
            }
        },
        /**条件查询试卷库 */
        searchPaper() {
            this.paperPages.current = 1;
            this.paperBankPageList();
        },
        /**切换试卷 */
        changePaper(item) {
            if(this.isDetail)return;
            if (this.currentPaperIds[item.id] == undefined) {
                this.$set(this.currentPaperIds, item.id, item);
            } else {
                this.$delete(this.currentPaperIds, item.id);
                this.$delete(this.excludeSub,item.id);
            }
            this.paperQuestionPageList();
        },
        /**分页查询试卷库 */
        paperBankPageList() {
            let params = {
                "classifyCode": this.classifyCode,
                "current": this.paperPages.current,
                "size": this.paperPages.size,
                "testPaperName": this.paperPages.keywords
            };
            PaperBankPageList(params).then(res => {
                if (res.code == 200) {
                    if (this.paperPages.current == 1) {
                        this.paperList = res.data.records;
                    } else {
                        this.paperList = [...this.paperList, res.data.records];
                    }
                }
            })
        },
        /**分页查询题目 */
        paperQuestionPageList() {
            let arr = [];
            for (let key in this.currentPaperIds) {
                arr.push(key);
            }
            let params = {
                "current": this.pages.current,
                "questionName": this.pages.keywords,
                "questionType": this.pages.type,
                "size": this.pages.size,
                "testPaperIds": arr
            };
            PaperQuestionPageList(params).then(res => {
                if (res.code == 200) {
                    res.data.records.forEach(item => {
                        let el = this.clearQuestionIds.find(e => e.questionId == item.questionId);
                        if (el) {
                            item.flag = false;
                            return;
                        }
                        item.flag = true;
                    });
                    this.tableData = res.data.records;
                    this.pages.total = res.data.total;
                }
            })
        },
    },
    computed: {
        querySubTotal() {
            let obj = {
                '判断题': 0,
                '填空题': 0,
                '单选题': 0,
                '多选题': 0
            };
            for (let key in this.currentPaperIds) {
                for (let key1 in obj) {
                    let count =this.currentPaperIds[key].questionCountMap?this.currentPaperIds[key].questionCountMap[key1]:0;
                    if (count) {
                        obj[key1] = obj[key1] + count;
                    }
                }
            }
            for(let key in obj){
                for(let key1 in this.excludeSub){
                    if(this.excludeSub[key1][key]){
                        obj[key]=obj[key]-this.excludeSub[key1][key];
                    }
                }
            }
            return obj;
        },
        computedTotalScore() {
            let sum = 0;
            this.randomConfig.forEach(item => {
                sum = sum + this.querySubTotal[item.label] * (item.score||0);
            })
            return sum;
        }
    },
    mounted() {
        this.paperBankPageList();
    }
}
</script>

<style lang="less" scoped>
.box {
    height: 100%;
    background: #ffffff;
    border: 1px solid #e0e8f2;
    border-radius: 16px;
    position: relative;
    overflow: hidden
}

.series {
    position: absolute;
    right: 0;
    top: 0;
    width: 3rem;
    height: 3rem;
    color: #ffffff;
    background: #387dff;
    border: 1px solid #e0e8f2;
    display: flex;
    font-weight: 700;
    font-size: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 0px 16px 0px 2.2rem;
}

.require {
    font-size: 12px;
    color: #FF0000;
}

.top-box {
    height: 5rem;
    background-color: #FBFCFF;
    display: flex;
    align-items: center;
    padding: 0 5rem;
}

.content-box {
    height: calc(100% - 5rem);
    display: flex;

    .left-box {
        width: 30rem;
        padding: 0 2rem 0 3rem;

        .left-title {
            font-weight: 700;
            margin: 2rem 0;
            font-size: 16px;
        }

        .list-box {
            height: calc(100% - 9rem);
            overflow: auto;
            box-sizing: content-box;
            padding-right: 1rem;
            &> :nth-child(n) {
                margin-top: 1.5rem;
            }

            &> :nth-child(1) {
                margin-top: 0;
            }
        }
    }

    .right-box {
        width: 60rem;
    }

    .center-box {
        width: calc(100% - 90rem);

        .center-table-box {
            height: calc(100% - 9rem);
        }
    }
}

.paper-item {
    padding: 1.1rem 2.5rem;
    border: 1px solid #e5edf7;
    border-radius: 0.8rem;
    cursor: pointer;
    box-shadow: 0px 0px 1.5rem 0px rgba(231, 236, 239, 0.10);
    position: relative;

    .active-line {
        position: absolute;
        top: 5%;
        left: 0;
        background-color: var(--blue);
        width: 3px;
        height: 90%;
    }

    .paper-item-title {
        font-weight: 700;
    }

    .paper-bottom {
        display: flex;
        justify-content: space-between;
        margin-top: 1.1rem;

        .p-item {
            display: flex;

            &> :nth-child(1) {
                color: #8590B3;
            }

            &> :nth-child(2) {
                color: #334681;
            }

            &> :nth-child(3) {
                color: #8590B3;
            }
        }
    }
}

.center-top {
    display: flex;
    justify-content: flex-end;
    padding: 1.1rem 0;

    .search-box {
        display: flex;
        align-items: center;

        &> :nth-child(1) {
            margin-right: 1.3rem;
        }
    }
}

.center-top {
    /deep/.el-input__inner {
        height: 4rem !important;
    }
}

.search-ipt-box {
    display: flex;
    align-items: center;
    width: 3.5rem;
    justify-content: center;
    height: 100%;
}

.exam-content {
    height: 100%;
    padding: 1rem 2rem;
    overflow: auto;
}

.sub-item {
    margin-top: 1.5rem;
    display: flex;
    align-items: center;
    font-size: 14px;
}

.number-gap {
    margin: 0 0.5rem;
    width: 4rem;
    color: var(--blue);
    text-align: center;
}

.number-input-box {
    margin: 0 1.5rem;
    width: 12rem !important;
}

.form-item {
    display: flex;
    align-items: center;
}

.exam-bottom-box {
    margin-top: 2rem;
    display: flex;
    flex-direction: column;

    &> :nth-child(n) {
        margin-top: 2rem;
    }
}

.content {
    &> :nth-child(n) {
        margin-top: 1.5rem;
    }

    &> :nth-child(1) {
        margin-top: 0;
    }
}

.item {
    display: flex;
    align-items: center;

    .input-title {
        margin-right: 2.5rem;
    }
}

.paper-active {
    background-color: #E5EDF7;
    border: none;
    color: #387DFF;
}
</style>